import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { LOCAL_BUSINESS_LD } from "@/data/site";

/* Gestion SEO sans dépendance : title, meta, OG, JSON-LD */
export const Seo = ({ title, description, jsonLd = [], noindex = false }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = title;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const url = `${window.location.origin}${pathname}`;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex,follow" : "index,follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", `${window.location.origin}/og-image.jpg`); /* TODO: créer l'image OG 1200x630 */
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    document.querySelectorAll('script[data-seo-ld]').forEach((s) => s.remove());
    [LOCAL_BUSINESS_LD, ...jsonLd].forEach((ld) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoLd = "1";
      script.textContent = JSON.stringify(ld);
      document.head.appendChild(script);
    });
  }, [title, description, pathname, noindex]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
